function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "pineappleselected",
  transform: "translate(0 -0.001)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_38",
  "data-name": "Group 38",
  transform: "translate(68.828 0.001)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_168",
  "data-name": "Path 168",
  d: "M357.4,132.187c-17.819,17.819-39.208,25.322-47.773,16.757s-1.062-29.953,16.757-47.773,39.208-25.322,47.773-16.757S375.221,114.367,357.4,132.187Z",
  transform: "translate(-196.764 -33.803)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_34",
  "data-name": "Group 34",
  transform: "translate(32.401)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_32",
  "data-name": "Group 32"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_169",
  "data-name": "Path 169",
  d: "M273.807,17.232A76.3,76.3,0,0,0,254.522.341a2.211,2.211,0,0,0-3.176,2.8c16.368,36.516,7.925,80.28-23.486,106.56a87.965,87.965,0,0,1-53.935,20.466A76.4,76.4,0,0,0,273.807,17.232Z",
  transform: "translate(-173.925 -0.001)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_170",
  "data-name": "Path 170",
  d: "M252.4,114.181a76.389,76.389,0,0,0,9.57-107.605q-2.337-2.794-4.881-5.3a2.165,2.165,0,0,0-.374,2.4c16.368,36.516,7.925,80.28-23.486,106.56a87.72,87.72,0,0,1-46.466,19.918A76.248,76.248,0,0,0,252.4,114.181Z",
  transform: "translate(-179.289 -0.533)",
  fill: "#65ccb8"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_33",
  "data-name": "Group 33",
  transform: "translate(53.742 78.643)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_171",
  "data-name": "Path 171",
  d: "M390.892,152.2a76.3,76.3,0,0,1,16.89,19.285,2.211,2.211,0,0,1-2.8,3.176c-36.516-16.368-80.28-7.925-106.56,23.486a87.965,87.965,0,0,0-20.466,53.935A76.4,76.4,0,0,1,390.892,152.2Z",
  transform: "translate(-266.261 -135.12)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_172",
  "data-name": "Path 172",
  d: "M301.957,190.81a76.39,76.39,0,0,1,107.605-9.57q2.794,2.337,5.3,4.881a2.165,2.165,0,0,1-2.4.374c-36.516-16.368-80.28-7.925-106.56,23.486a87.72,87.72,0,0,0-19.918,46.466,76.247,76.247,0,0,1,15.966-65.637Z",
  transform: "translate(-273.742 -146.956)",
  fill: "#65ccb8"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_37",
  "data-name": "Group 37",
  transform: "translate(0 6.796)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_35",
  "data-name": "Group 35",
  transform: "translate(59.338 97.263)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_173",
  "data-name": "Path 173",
  d: "M364.936,202.869a85.167,85.167,0,0,1,16.87,23.108,2.468,2.468,0,0,1-3.423,3.254c-38.973-21.805-88.457-16.746-120.775,15.573a98.169,98.169,0,0,0-28.082,57.931,85.286,85.286,0,0,1,14.53-97.94c32.673-33.895,87.166-34.784,120.881-1.925Z",
  transform: "translate(-220.207 -178.787)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_174",
  "data-name": "Path 174",
  d: "M262.251,236.993a85.249,85.249,0,0,1,120.561,0q2.874,2.874,5.411,5.95a2.416,2.416,0,0,1-2.7.179c-38.973-21.805-88.457-16.746-120.775,15.573a97.9,97.9,0,0,0-26.734,49.683,85.1,85.1,0,0,1,24.238-71.385Z",
  transform: "translate(-227.347 -192.679)",
  fill: "#65ccb8"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_36",
  "data-name": "Group 36"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_175",
  "data-name": "Path 175",
  d: "M218.122,28.82A85.167,85.167,0,0,0,195.014,11.95a2.468,2.468,0,0,0-3.254,3.423c21.805,38.973,16.746,88.457-15.573,120.775a98.169,98.169,0,0,1-57.931,28.082A85.286,85.286,0,0,0,216.2,149.7c33.895-32.673,34.784-87.166,1.925-120.881Z",
  transform: "translate(-118.256 -11.678)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_176",
  "data-name": "Path 176",
  d: "M203.812,139.36a85.249,85.249,0,0,0,0-120.561q-2.874-2.874-5.95-5.411a2.416,2.416,0,0,0-.179,2.7c21.805,38.973,16.746,88.457-15.573,120.775A97.9,97.9,0,0,1,132.427,163.6,85.1,85.1,0,0,0,203.812,139.36Z",
  transform: "translate(-124.179 -12.393)",
  fill: "#65ccb8"
})))), /*#__PURE__*/React.createElement("path", {
  id: "Path_177",
  "data-name": "Path 177",
  d: "M315.976,167.731,200.281,52.036c9.789,31.307,4.376,66-16.41,92.334a88.724,88.724,0,0,1-33.213,7.544,76.065,76.065,0,0,0,17.683,8.155A98.353,98.353,0,0,1,118.256,181.1a85.5,85.5,0,0,0,62.761,5.9,85.5,85.5,0,0,0,5.9,62.761,98.36,98.36,0,0,1,21.031-50.085,76.033,76.033,0,0,0,8.155,17.683,88.721,88.721,0,0,1,7.544-33.213c26.337-20.786,61.027-26.2,92.334-16.41Z",
  transform: "translate(-49.428 -21.749)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_41",
  "data-name": "Group 41",
  transform: "translate(0 82.097)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_178",
  "data-name": "Path 178",
  d: "M27.427,328.363a93.641,93.641,0,0,1,0-132.429L54.882,168.48A93.641,93.641,0,0,1,187.31,300.909l-27.455,27.455a93.641,93.641,0,0,1-132.429,0Z",
  transform: "translate(0 -141.053)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_39",
  "data-name": "Group 39",
  transform: "translate(0.004 18.04)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_179",
  "data-name": "Path 179",
  d: "M187.313,313.864l-27.455,27.455A93.641,93.641,0,1,1,27.43,208.89l27.455-27.455a94.607,94.607,0,0,1,10.937-9.387,213.683,213.683,0,0,1,41.126,4.361c46.015,9.387,84.242,32.4,107.243,61.095a95.855,95.855,0,0,1,.545,10.146,93.335,93.335,0,0,1-27.422,66.214Z",
  transform: "translate(-0.006 -172.048)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_180",
  "data-name": "Path 180",
  d: "M203.051,327.208a93.512,93.512,0,0,1-15.738,20.866l-27.455,27.455A93.653,93.653,0,0,1,16.4,256.351a205.13,205.13,0,0,1,73.591,1.91C140.132,268.487,181.023,294.9,203.051,327.208Z",
  transform: "translate(-0.006 -206.258)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_181",
  "data-name": "Path 181",
  d: "M.164,338.088a205.3,205.3,0,0,1,72.868,2.027c42.535,8.676,78.415,29,101.768,54.683L159.858,409.74A93.617,93.617,0,0,1,.164,338.088Z",
  transform: "translate(-0.006 -240.47)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_182",
  "data-name": "Path 182",
  d: "M33.823,443.952a93.416,93.416,0,0,1-18.52-26.3,213.082,213.082,0,0,1,47.166,4.32c32.526,6.629,61.16,20.074,83.277,37.524a93.685,93.685,0,0,1-111.922-15.54Z",
  transform: "translate(-6.4 -274.681)",
  fill: "#65ccb8"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_40",
  "data-name": "Group 40",
  transform: "translate(0.002 0.005)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_183",
  "data-name": "Path 183",
  d: "M54.883,168.484,27.428,195.939A93.642,93.642,0,1,0,159.857,328.368l27.455-27.455a94.608,94.608,0,0,0,9.387-10.937,213.686,213.686,0,0,0-4.361-41.126c-9.387-46.015-32.4-84.242-61.095-107.243a95.7,95.7,0,0,0-10.146-.545,93.338,93.338,0,0,0-66.214,27.422Z",
  transform: "translate(-0.003 -141.062)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_184",
  "data-name": "Path 184",
  d: "M75.749,161.136a93.511,93.511,0,0,0-20.866,15.738L27.428,204.329a93.654,93.654,0,0,0,119.178,143.46A205.129,205.129,0,0,0,144.7,274.2c-10.227-50.142-36.64-91.033-68.948-113.062Z",
  transform: "translate(-0.003 -149.452)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_185",
  "data-name": "Path 185",
  d: "M99.081,384.31a205.3,205.3,0,0,0-2.027-72.868c-8.676-42.535-29-78.415-54.683-101.768L27.429,224.616A93.617,93.617,0,0,0,99.081,384.31Z",
  transform: "translate(-0.003 -169.74)",
  fill: "#65ccb8"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_186",
  "data-name": "Path 186",
  d: "M27.428,382.5a93.416,93.416,0,0,0,26.3,18.52,213.078,213.078,0,0,0-4.32-47.166C42.783,321.331,29.338,292.7,11.889,270.58A93.685,93.685,0,0,0,27.428,382.5Z",
  transform: "translate(-0.003 -195.197)",
  fill: "#65ccb8"
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_187",
  "data-name": "Path 187",
  d: "M15.664,259.992A93.658,93.658,0,0,0,145.514,389.841Z",
  transform: "translate(-0.002 -190.766)",
  fill: "#65ccb8"
})));

function SvgPineappleselected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 296.834,
    height: 296.834,
    viewBox: "0 0 296.834 296.834",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPineappleselected);
export default __webpack_public_path__ + "static/media/pineappleselected.2d470fe4.svg";
export { ForwardRef as ReactComponent };